exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../LMSGstyle.css"), "");

// module
exports.push([module.id, "\n.information_check_no[data-v-2b34a179] {\n  color: #49A0A2;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b34a179","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/LMSGiframe/components/DocumentTypeForm.vue
// module id = 1523
// module chunks = 2